import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { couponApiService } from 'services/couponApiService';

const UpdateCouponModal = ({
  isOpen,
  toggle,
  coupon,
  onUpdateSuccess
}) => {
  const [formData, setFormData] = useState({
    pro_name: '',
    promocode: '',
    promo_percentage: '',
    is_freedelivery: false,
    is_percentage: false,
    promo_fixedamount: '',
    is_fixedamount: false,
    activestatus: false,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (coupon) {
      setFormData({
        pro_name: coupon.pro_name || '',
        promocode: coupon.promocode || '',
        promo_percentage: coupon.promo_percentage || '',
        is_freedelivery: coupon.is_freedelivery || false,
        is_percentage: coupon.is_percentage || false,
        promo_fixedamount: coupon.promo_fixedamount || '',
        is_fixedamount: coupon.is_fixedamount || false,
        activestatus: coupon.activestatus || false,
      });
    }
  }, [coupon]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value === 'true'
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await couponApiService.updateCoupon(coupon.id, formData);
      onUpdateSuccess();
      toggle();
    } catch (error) {
      console.error('Error updating coupon:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Update Coupon</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <div className="row">
            <div className="col-md-6">
              <FormGroup>
                <Label for="pro_name">Promo Name *</Label>
                <Input
                  type="text"
                  id="pro_name"
                  name="pro_name"
                  value={formData.pro_name}
                  onChange={handleChange}
                  required
                />
              </FormGroup>



              <FormGroup>
                <Label for="promo_percentage">Promo Percentage</Label>
                <Input
                  type="number"
                  id="promo_percentage"
                  name="promo_percentage"
                  value={formData.promo_percentage}
                  onChange={handleChange}
                  placeholder="Enter percentage"
                  min="0"
                  max="100"
                />
              </FormGroup>

              <FormGroup>
                <Label for="is_freedelivery">Free Delivery</Label>
                <Input
                  type="select"
                  id="is_freedelivery"
                  name="is_freedelivery"
                  value={formData.is_freedelivery}
                  onChange={handleSelectChange}
                >
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </Input>
              </FormGroup>

              <FormGroup>
                <Label for="is_percentage">Is Percentage Discount</Label>
                <Input
                  type="select"
                  id="is_percentage"
                  name="is_percentage"
                  value={formData.is_percentage}
                  onChange={handleSelectChange}
                >
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </Input>
              </FormGroup>
            </div>

            <div className="col-md-6">
              <FormGroup>
                <Label for="promocode">Promo Code *</Label>
                <Input
                  type="text"
                  id="promocode"
                  name="promocode"
                  value={formData.promocode}
                  onChange={handleChange}
                  required
                />
              </FormGroup>

              <FormGroup>
                <Label for="promo_fixedamount">Promo Fixed Amount</Label>
                <Input
                  type="number"
                  id="promo_fixedamount"
                  name="promo_fixedamount"
                  value={formData.promo_fixedamount}
                  onChange={handleChange}
                  placeholder="Enter fixed amount"
                  min="0"
                />
              </FormGroup>





              <FormGroup>
                <Label for="is_fixedamount">Is Fixed Amount Discount</Label>
                <Input
                  type="select"
                  id="is_fixedamount"
                  name="is_fixedamount"
                  value={formData.is_fixedamount}
                  onChange={handleSelectChange}
                >
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </Input>
              </FormGroup>

              <FormGroup>
                <Label for="activestatus">Active Status</Label>
                <Input
                  type="select"
                  id="activestatus"
                  name="activestatus"
                  value={formData.activestatus}
                  onChange={handleSelectChange}
                >
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </Input>
              </FormGroup>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle} disabled={loading}>
            Cancel
          </Button>
          <Button color="primary" type="submit" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-1"></span>
                Updating...
              </>
            ) : (
              'Update Coupon'
            )}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default UpdateCouponModal;